import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { DATE_OPTIONS } from 'modules/jogador/booking/content';
import { fetchCourtAvailability, fetchDateOptions } from 'modules/jogador/booking/bookingService';
import { Court, SelectedSlot } from 'modules/jogador/booking/types';
import { ROUTES } from 'shared/constants/routes';

export function useBooking() {
  const { data: dates } = useAsyncData(fetchDateOptions, DATE_OPTIONS);
  const [selectedDateId, setSelectedDateId] = useState(DATE_OPTIONS[1].id);
  const { data: courts, isLoading, error } = useAsyncData<Court[]>(
    () => fetchCourtAvailability(selectedDateId),
    [],
    [selectedDateId]
  );
  const [selectedSlot, setSelectedSlot] = useState<SelectedSlot | null>(null);
  const [splitEnabled, setSplitEnabled] = useState(false);
  const [maxPlayers, setMaxPlayers] = useState(2);
  const navigate = useNavigate();

  function selectSlot(court: Court, time: string) {
    setSelectedSlot({ courtId: court.id, courtName: court.name, time, pricePerHour: court.pricePerHour });
  }

  function toggleSplit() {
    setSplitEnabled((prev) => !prev);
  }

  function goToCheckout() {
    if (!selectedSlot) return;

    const selectedDate = dates.find((date) => date.id === selectedDateId);

    navigate(ROUTES.CHECKOUT, {
      state: {
        courtName: selectedSlot.courtName,
        time: selectedSlot.time,
        pricePerHour: selectedSlot.pricePerHour,
        dateLabel: selectedDate ? `${selectedDate.weekday} ${selectedDate.day}` : '',
        splitEnabled,
        maxPlayers,
      },
    });
  }

  return {
    dates,
    selectedDateId,
    setSelectedDateId,
    courts,
    isLoading,
    error,
    selectedSlot,
    selectSlot,
    splitEnabled,
    toggleSplit,
    maxPlayers,
    setMaxPlayers,
    goToCheckout,
  };
}
